import adminPanel from "./adminPanel.json";
import auth from "./auth.json";
import menu from "./menu.json";
import home from "./home.json";
import common from "./common.json";

const enMsg = {
  ...home,
  ...adminPanel,
  ...auth,
  ...menu,
  ...common,
};

export default enMsg;
